import { render, staticRenderFns } from "./Patent-details.vue?vue&type=template&id=28d73343&scoped=true&"
import script from "./Patent-details.vue?vue&type=script&lang=js&"
export * from "./Patent-details.vue?vue&type=script&lang=js&"
import style0 from "./Patent-details.vue?vue&type=style&index=0&id=28d73343&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d73343",
  null
  
)

export default component.exports